import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { missingSettings } from "@/config/env";
import { ConfigMissing } from "@/pages/ConfigMissing";
import "@/index.css";

// Without its settings the app would send every request to the wrong place and wait forever.
const missing = missingSettings();

createRoot(document.getElementById("root")!).render(
  missing.length ? (
    <ConfigMissing missing={missing} />
  ) : (
    <StrictMode>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </StrictMode>
  ),
);
